/**
 * Confetti Hook
 *
 * Provides confetti celebration effects for big wins.
 * Uses canvas-confetti for lightweight, performant animations.
 */

import confetti from 'canvas-confetti';

// Brand colors from design tokens
const CELEBRATION_COLORS = [
  '#6B5B95', // primary purple
  '#F4A261', // accent orange
  '#82C99A', // health green
  '#C99AC8', // social pink
  '#FFEAA7', // learning yellow
];

/**
 * Fires a celebratory confetti burst for big wins.
 * Uses a dual-burst from both sides for a satisfying "achievement unlocked" feel.
 */
function fireBigWinConfetti(): void {
  const defaults = {
    colors: CELEBRATION_COLORS,
    ticks: 200,
    gravity: 1.2,
    decay: 0.94,
    startVelocity: 30,
  };

  // Left burst
  confetti({
    ...defaults,
    particleCount: 80,
    angle: 60,
    spread: 55,
    origin: { x: 0, y: 0.7 },
  });

  // Right burst
  confetti({
    ...defaults,
    particleCount: 80,
    angle: 120,
    spread: 55,
    origin: { x: 1, y: 0.7 },
  });
}

export function useConfetti() {
  return {
    celebrateBigWin: fireBigWinConfetti,
  };
}
